import { useState } from "react";
import { useLang } from "../../context/LangContext";
import { useCMS } from "../../context/CMSContext";
import styles from "./FAQ.module.css";

export default function FAQ() {
  const { lang } = useLang();
  const { cms } = useCMS();
  const [open, setOpen] = useState(null);

  const items = cms?.faq?.items ?? [];
  if (items.length === 0) return null;

  return (
    <section id="faq" className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>
          {lang === "tr" ? "Sık Sorulan Sorular" : "Frequently Asked Questions"}
        </h2>
        <div className={styles.list}>
          {items.map((item) => {
            const isOpen = open === item.id;
            return (
              <div
                key={item.id}
                className={`${styles.item} ${isOpen ? styles.itemOpen : ""}`}
              >
                <button
                  className={styles.question}
                  onClick={() => setOpen(isOpen ? null : item.id)}
                >
                  <span>{item[`q_${lang}`] || item.q_en}</span>
                  <span
                    className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ""}`}
                  >
                    ›
                  </span>
                </button>
                {isOpen && (
                  <p className={styles.answer}>
                    {item[`a_${lang}`] || item.a_en}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
